import { Box } from "@material-ui/core";
import React from "react";

const NavTopSpacer = () => {
  return <Box style={{ height: 60 }}></Box>;
};

export default NavTopSpacer;
